import React from "react";
import ReactPaginate from "react-paginate";
import "./style.css"
const TableUi = ({
  columns, // Array of column definitions
  data, // Array of table data
  pagination, // Pagination configuration
  onPageChange, // Function to handle page changes
  msg
}) => {
  return (
    <>
      <table className="table table-bordered table-striped">
        <thead>
          <tr>
            {columns?.map((col, index) => (
              <th key={index}>{col?.title}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data?.length > 0 ? (
            data.map((row, rowIndex) => (
              <tr key={rowIndex}>
                {columns?.map((col, colIndex) => (
                  <td
                    key={colIndex}
                    className="table-td"
                    style={{ width: (col.title == "Actions" || col.title === "Mandatory") ? "80px" :col.title == "Date" ? "120px" : "" }}
                  >
                    {/* {col.render
                      ? col.render(row[col.dataKey], row)
                      : col.isObject 
                      ? row[col.dataKey][col.objectKey]
                      : row[col.dataKey]} */}
                    {/* {col?.render
                      ? col?.render(row[col.dataKey], row)
                      : col?.isObject
                      ? col?.subObjectKey
                        ? row[col.dataKey]?.[col.objectKey]?.[
                            col.subObjectKey
                          ] || "N/A"
                        : row[col.dataKey]?.[col.objectKey] || "N/A"
                      : row[col.dataKey]} */}
                    {col?.render
                      ? col?.render(row[col.dataKey], row)
                      : col?.isObject
                      ? col?.subObjectKey
                        ? col?.subObjectSubKey
                          ? row[col.dataKey]?.[col.objectKey]?.[
                              col.subObjectKey
                            ]?.[col.subObjectSubKey] || "N/A"
                          : row[col.dataKey]?.[col.objectKey]?.[
                              col.subObjectKey
                            ] || "N/A"
                        : row[col.dataKey]?.[col.objectKey] || "N/A"
                      : row[col.dataKey]}
                  </td>
                ))}
              </tr>
            ))
          ) : (
            <tr>
              <td style={{width:"100%"}} colSpan={columns.length}><p className="text-center mb-0">{msg ? msg : "No data available"}</p></td>
            </tr>
          )}
        </tbody>
      </table>

      {/* Add Pagination */}
      {/* Add Pagination */}
      {(data.length > 0 && pagination > 1) && (
        <div className="d-flex justify-content-center mt-3">
          <ReactPaginate
            pageCount={pagination}
            pageRangeDisplayed={5}
            marginPagesDisplayed={5}
            onPageChange={
              (e) => onPageChange(e.selected + 1) // e.selected is 0-indexed
            }
            containerClassName={"pagination-class"}
            pageClassName={"pagination-page-item"}
            activeClassName={"pagination-active"}
            // previousLabel={"Previous"}
            // nextLabel={"Next"}
            previousLabel={
              <div
                style={{
                  color: "#B8C1CC",
                  size: "36px",
                  marginRight: "10px",
                }}
              >
                <i class="fas fa-chevron-left"></i>
              </div>
            }
            nextLabel={
              <div
                style={{
                  color: "#B8C1CC",
                  size: "36px",
                  marginLeft: "10px",
                }}
              >
                <i class="fas fa-chevron-right"></i>
              </div>
            }
          />
        </div>
      )}
    </>
  );
};

export default TableUi;
